import colors from './theme-items/colors';
import media from './theme-items/media';
import icons from './theme-items/icons';
import screenReader from './theme-items/screenReader';
import sizes from './theme-items/sizes';
import buttons from './theme-items/buttons';
import textStyles from './theme-items/textVariants';
import colorModes from './theme-items/modes/colorModes';
import { breakpointPxs as breakpoints } from './theme-items/breakpoints';
import mediaSizes from './theme-items/mediaSizes';
import { fonts, fontWeights, fontStyles, lineHeights, fontSizes, bodySizes, headingSizes, iconSize, space, } from './theme-items';
var containerWidths = ['932px', '1132px', '1192px'];
var styledTheme = {
    breakpoints: breakpoints,
    colors: colors,
    containerWidths: containerWidths,
    media: media,
    mediaSizes: mediaSizes,
    fonts: fonts,
    fontSizes: fontSizes,
    icons: icons,
    screenReader: screenReader,
    iconSize: iconSize,
    space: space,
    sizes: sizes,
    buttons: buttons,
    textStyles: textStyles,
    colorModes: colorModes,
    lineHeights: lineHeights,
    fontWeights: fontWeights,
    fontStyles: fontStyles,
    headingSizes: headingSizes,
    bodySizes: bodySizes,
};
export { styledTheme, breakpoints, colors, containerWidths, media, mediaSizes, fonts, fontSizes, icons, screenReader, iconSize, space, sizes, buttons, colorModes, lineHeights, fontWeights, fontStyles, headingSizes, bodySizes, textStyles, };
//# sourceMappingURL=index.js.map